export const HOME_ROUTE = '/';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const FORGOT_PASSWORD = '/forgorPassword';
export const FORM_TEMPLATE = '/formTemplate';
export const YOU_PORTAL = '/youPortal/:idUser';
